import { z } from 'zod';

export const BluetoothStateChangedSchema = z.object({
  usable: z.boolean(),
  state: z.enum(['poweredOn', 'poweredOff', 'unauthorized', 'unsupported', 'resetting', 'unknown']),
  authorization: z.string(),
  message: z.string(),
  canRecover: z.boolean(),
  action: z.enum(['none', 'enableBluetooth', 'openSettings', 'unsupported', 'wait']),
});

export type BluetoothStateChanged = z.infer<typeof BluetoothStateChangedSchema>;
